// extracted by mini-css-extract-plugin
export default {"private":"Template_private__MI9yg","public":"Template_public__93dOj","logo":"Template_logo__0awWl"};